import { PodiumGoldIcon } from './PodiumGoldIcon';

/**
 * author: Michael Richins
 * id CB4B60CC-1B22-4288-997F-D59FE2AFC198
 * name podium-gold
 * version: 3.3.92
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/podium-gold.svg
 * tags
 * - Sport 
 */
export const PodiumFirstIcon = PodiumGoldIcon;
export default PodiumFirstIcon